import readingTypes from './readingTypes-en-US.json';
import cards from './cards-en-US.json';

const enUSTranslations = {
    "title": "Welcome {{name}}, to react using react-i18next fully type-safe",
    "splashScreen": {
        "title": "Messages that guide, balance that flourishes",
        "mobileAccess": "Please access through a mobile device"
    },
    "login": {
        "title": "Sign In",
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "signInButton": "Sign In",
        "orSignInWith": "Or sign in with",
        "signInWithGoogle": "Sign In with Google",
        "signInWithApple": "Sign In with Apple",
        "signInWithFacebook": "Sign In with Facebook",
        "noAccount": "Don't have an account?",
        "register": "Register",
        "forgotPassword": "Forgot your password?",
        "resetHere": "Reset it here",
        "errorFillFields": "Please fill out all fields",
        "errorInvalidCredentials": "Invalid credentials, please try again.",
        "errorGoogleLogin": "Failed to login with Google",
        "errorGoogleLoginGeneric": "Google login failed"
    },
    "register": {
        "title": "Create Account",
        "firstNameLabel": "First Name",
        "lastNameLabel": "Last Name",
        "emailLabel": "Email",
        "passwordLabel": "Password",
        "confirmPasswordLabel": "Confirm Password",
        "registerButton": "Register",
        "orRegisterWith": "Or register with",
        "registerWithGoogle": "Register with Google",
        "registerWithApple": "Register with Apple",
        "registerWithFacebook": "Register with Facebook",
        "hasAccount": "Already have an account?",
        "signIn": "Sign In",
        "errorFillFields": "Please fill out all required fields",
        "errorPasswordsMatch": "Passwords do not match",
        "errorRegistrationFailed": "Registration failed",
        "errorGoogleRegistration": "Failed to register with Google",
        "errorGoogleRegistrationGeneric": "Google registration failed"
    },
    "forgotPassword": {
        "title": "Reset Password",
        "description": "Enter your email address and we'll send you instructions to reset your password.",
        "emailLabel": "Email",
        "resetButton": "Reset Password",
        "rememberPassword": "Remember your password?",
        "signIn": "Sign In",
        "errorEnterEmail": "Please enter your email address",
        "errorResetFailed": "Failed to process, user not found.",
        "successResetSent": "Password reset instructions have been sent to your email"
    },
    "modeSelector": {
        "title": "What Mysteries Seek You?",
        "digitalCards": "Digital Cards",
        "physicalCards": "Physical Cards",
        "comingSoon": "Coming Soon",
        "questionLabel": "What would you like to know?",
        "questionPlaceholder": "Share your question with the universe... (e.g., 'I seek guidance about...')",
        "beginReading": "Begin Reading"
    },
    "cameraCapture": {
        "yourPhotos": "Your Photos",
        "noPhotosYet": "No photos yet. Start capturing!",
        "galleryPreview": "Gallery Preview"
    },
    "readingCards": {
        "readingFortune": "Interpreting your cards...",
        "readingCards": "Reading your Cards",
        "sessionExpired": "Session expired. Please login again.",
        "errorReading": "Error during tarot reading. Please try again.",
        "cardsShuffledMessage": "Your cards are shuffled, if you want, you  can shuffle again."
    },
    "feedback": {
        "title": "Thanks for sending us your ideas, issues, or appreciations.",
        "description": "We can't respond individually, but we'll pass it on to the teams who are working to help make Plenamente better for everyone.",
        "helpCenter": "If you do have a specific question, or need help resolving a problem, you can visit our Help Center or contact us to connect with our support team.",
        "helpCenterLink": "Help Center",
        "contactLink": "contact us",
        "feedbackAbout": "What's your feedback about?",
        "topicFeature": "What topic or feature?",
        "addDetails": "Add details",
        "submit": "Submit",
        "thankYou": "Thank you for your feedback!",
        "errorSubmitting": "Error submitting feedback. Please try again.",
        "categories": {
            "experiences": "Experiences",
            "technical": "Technical",
            "other": "Other"
        },
        "topics": {
            "experienceQuality": "Experience quality & communication",
            "appFunctionality": "App functionality",
            "readingExperience": "Reading experience",
            "journalFeatures": "Journal features",
            "accountSettings": "Account & settings",
            "performanceStability": "Performance & stability",
            "other": "Other"
        }
    },
    "notifications": {
        "searchMessages": "Search Messages",
        "tabs": {
            "all": "All",
            "support": "Support",
            "reading": "Reading",
            "message": "Message"
        },
        "notifications": [
            {
                "title": "Your Daily Reading is Ready",
                "description": "Your Three Card Spread reading for today is now available"
            },
            {
                "title": "New message from your Tarot Advisor",
                "description": "I've reviewed your recent reading and have some additional insights to share"
            },
            {
                "title": "Reading Session Confirmed",
                "description": "Your live reading session with Sarah is scheduled for tomorrow at 2 PM"
            },
            {
                "title": "Weekly Forecast Complete",
                "description": "Your weekly tarot forecast has been generated. Check it out!"
            },
            {
                "title": "Community Discussion",
                "description": "New responses in 'Understanding The Tower Card' thread"
            },
            {
                "title": "Subscription Renewed",
                "description": "Your premium tarot subscription has been successfully renewed"
            },
            {
                "title": "New Moon Reading Available",
                "description": "Special lunar phase reading is now ready for your review"
            },
            {
                "title": "Group Reading Invitation",
                "description": "You've been invited to join a group reading session this weekend"
            },
            {
                "title": "Account Milestone",
                "description": "You've completed 50 readings! Unlock your achievement badge"
            },
            {
                "title": "Celtic Cross Spread Complete",
                "description": "Your in-depth Celtic Cross reading results are ready"
            }
        ]
    },
    "superMarkets": {
        "title": "Super Markets"
    },
    "settings": {
        "personalInformation": "Personal information",
        "personalProfile": "Personal profile",
        "paymentsPayouts": "Payments and payouts",
        "notifications": "Notifications",
        "privacySharing": "Privacy and sharing",
        "feedback": "Feedback",
        "logout": "Logout",
        "saveChanges": "Save Changes",
        "profileUpdatedSuccess": "Profile updated successfully!",
        "profileSavedSuccess": "Profile saved successfully!",
        "errorUpdatingProfile": "Error updating profile. Please try again.",
        "fixValidationErrors": "Please fix the validation errors before submitting.",
        "loading": "Loading..."
    },
    "onboarding": {
        "steps": {
            "userGoal": "User Goal",
            "experience": "Experience",
            "deck": "Deck",
            "birthData": "Birth Data",
            "frequency": "Frequency",
            "aiTone": "AI Tone",
            "credits": "Credits",
            "privacy": "Privacy",
            "complete": "Complete"
        },
        "common": {
            "continue": "Continue",
            "skipForNow": "Skip for now",
            "beginReading": "Begin Reading"
        },
        "account": {
            "title": "Create your account",
            "advantages": {
                "saveReadings": "Save your readings",
                "personalNotes": "Personal notes",
                "syncedDevices": "Synced across devices",
                "aiInsights": "AI-powered insights",
                "dailyCompanion": "Daily guidance companion"
            }
        },
        "userGoal": {
            "title": "What would you like guidance on?",
            "options": {
                "loveRelationships": "Love & Relationships",
                "careerFinances": "Career & Finances",
                "personalGrowth": "Personal Growth",
                "healthWellbeing": "Health & Wellbeing",
                "curiosityExploration": "Curiosity & Exploration"
            }
        },
        "tarotExperience": {
            "title": "How familiar are you with tarot?",
            "options": {
                "newToTarot": "New to Tarot",
                "newToTarotDescription": "I'm just beginning",
                "someExperience": "Some Experience",
                "someExperienceDescription": "I know the basics",
                "experiencedReader": "Experienced Reader",
                "experiencedReaderDescription": "Well-versed in tarot"
            }
        },
        "deckPreference": {
            "title": "Choose your preferred deck style",
            "options": {
                "riderWaite": "Rider-Waite",
                "celestialMinimalist": "Celestial Minimalist",
                "thoth": "Thoth"
            }
        },
        "birthData": {
            "title": "Enter your birth details",
            "description": "This helps align your readings with your cosmic blueprint",
            "helpAlign": "This helps align your readings with your cosmic blueprint",
            "birthDate": "Birth Date",
            "birthTime": "Birth Time (if known)",
            "birthPlace": "Birth Place",
            "birthPlacePlaceholder": "City, Country",
            "cityCountryPlaceholder": "City, Country"
        },
        "readingFrequency": {
            "title": "How often do you want readings?",
            "options": {
                "daily": "Daily",
                "dailyDescription": "Start each day with guidance",
                "weekly": "Weekly",
                "weeklyDescription": "Deeper insights once a week",
                "occasionally": "Occasionally",
                "occasionallyDescription": "Only when you need guidance"
            }
        },
        "aiTone": {
            "title": "How should the AI interpret your readings?",
            "description": "You can change this anytime in settings",
            "changeTime": "You can change this anytime in settings",
            "options": {
                "directPractical": "Direct & Practical",
                "directPracticalDescription": "Clear, actionable guidance",
                "gentleIntuitive": "Gentle & Intuitive",
                "gentleIntuitiveDescription": "Nurturing, supportive insights",
                "deepSymbolic": "Deep & Symbolic",
                "deepSymbolicDescription": "Profound, metaphorical wisdom"
            }
        },
        "creditIntro": {
            "title": "Understanding the credit system",
            "subtitle": "You start with 3 free credits",
            "description": "Each reading uses 1 credit. You can get more credits when needed.",
            "acknowledgment": "I understand how credits work",
            "startWithFreeCredits": "You start with 3 free credits",
            "eachReadingUsesOneCredit": "Each reading uses 1 credit. You can get more credits when needed.",
            "understandCredits": "I understand how credits work"
        },
        "privacy": {
            "title": "Your path is yours alone",
            "description": "Everything you see here is private and sacred. Your data is secure and only visible to you.",
            "acknowledgment": "I understand my readings are private",
            "everythingPrivate": "Everything you see here is private and sacred. Your data is secure and only visible to you.",
            "understandPrivateReadings": "I understand my readings are private"
        },
        "completion": {
            "title": "Your journey awaits",
            "description": "You're all set! Your tarot experience has been personalized based on your preferences.",
            "allSet": "You're all set! Your tarot experience has been personalized based on your preferences.",
            "beginReading": "Begin Reading"
        }
    },
    "cardsMeaningWidget": {
        "title": "Discover Card Meanings",
        "description": "Explore the rich symbolism and interpretations of all 78 tarot cards"
    },
    "customMessage": {
        "goodMorning": "Good Morning",
        "goodAfternoon": "Good Afternoon",
        "goodEvening": "Good Evening",
        "greeting": "{{greeting}}, {{name}}. Today it's {{date}}. Your day at glance:"
    },
    "journal": {
        "noEntriesYet": "No journal entries yet",
        "startJourney": "Start your journaling journey by adding your first entry",
        "addEntry": "Add Journal Entry",
        "title": "Title",
        "howAreYouFeeling": "How are you feeling?",
        "writeYourThoughts": "Write your thoughts...",
        "saveEntry": "Save Entry",
        "update": "Update",
        "save": "Save",
        "myDay": "My Day",
        "journal": "Journal",
        "moods": {
            "happy": "Happy",
            "calm": "Calm",
            "anxious": "Anxious",
            "stressed": "Stressed",
            "excited": "Excited",
            "neutral": "Neutral",
            "sad": "Sad",
            "angry": "Angry"
        }
    },
    "fastReadingCategory": {
        "questionLabel": "What would you like to know?",
        "beginReading": "Begin Reading",
        "noFavorites": "There are no favorite readings yet. Start reading to see your favorites here!"
    },
    "cards": {
        "majorArcana": {
            "theFool": "The Fool",
            "theMagician": "The Magician",
            "theHighPriestess": "The High Priestess",
            "theEmpress": "The Empress",
            "theEmperor": "The Emperor",
            "theHierophant": "The Hierophant",
            "theLovers": "The Lovers",
            "theChariot": "The Chariot",
            "strength": "Strength",
            "theHermit": "The Hermit",
            "wheelOfFortune": "Wheel of Fortune",
            "justice": "Justice",
            "theHangedMan": "The Hanged Man",
            "death": "Death",
            "temperance": "Temperance",
            "theDevil": "The Devil",
            "theTower": "The Tower",
            "theStar": "The Star",
            "theMoon": "The Moon",
            "theSun": "The Sun",
            "judgement": "Judgement",
            "theWorld": "The World"
        },
        "cups": {
            "aceOfCups": "Ace of Cups",
            "twoOfCups": "Two of Cups",
            "threeOfCups": "Three of Cups",
            "fourOfCups": "Four of Cups",
            "fiveOfCups": "Five of Cups",
            "sixOfCups": "Six of Cups",
            "sevenOfCups": "Seven of Cups",
            "eightOfCups": "Eight of Cups",
            "nineOfCups": "Nine of Cups",
            "tenOfCups": "Ten of Cups",
            "pageOfCups": "Page of Cups",
            "knightOfCups": "Knight of Cups",
            "queenOfCups": "Queen of Cups",
            "kingOfCups": "King of Cups"
        },
        "pentacles": {
            "aceOfPentacles": "Ace of Pentacles",
            "twoOfPentacles": "Two of Pentacles",
            "threeOfPentacles": "Three of Pentacles",
            "fourOfPentacles": "Four of Pentacles",
            "fiveOfPentacles": "Five of Pentacles",
            "sixOfPentacles": "Six of Pentacles",
            "sevenOfPentacles": "Seven of Pentacles",
            "eightOfPentacles": "Eight of Pentacles",
            "nineOfPentacles": "Nine of Pentacles",
            "tenOfPentacles": "Ten of Pentacles",
            "pageOfPentacles": "Page of Pentacles",
            "knightOfPentacles": "Knight of Pentacles",
            "queenOfPentacles": "Queen of Pentacles",
            "kingOfPentacles": "King of Pentacles"
        },
        "swords": {
            "aceOfSwords": "Ace of Swords",
            "twoOfSwords": "Two of Swords",
            "threeOfSwords": "Three of Swords",
            "fourOfSwords": "Four of Swords",
            "fiveOfSwords": "Five of Swords",
            "sixOfSwords": "Six of Swords",
            "sevenOfSwords": "Seven of Swords",
            "eightOfSwords": "Eight of Swords",
            "nineOfSwords": "Nine of Swords",
            "tenOfSwords": "Ten of Swords",
            "pageOfSwords": "Page of Swords",
            "knightOfSwords": "Knight of Swords",
            "queenOfSwords": "Queen of Swords",
            "kingOfSwords": "King of Swords"
        },
        "wands": {
            "aceOfWands": "Ace of Wands",
            "twoOfWands": "Two of Wands",
            "threeOfWands": "Three of Wands",
            "fourOfWands": "Four of Wands",
            "fiveOfWands": "Five of Wands",
            "sixOfWands": "Six of Wands",
            "sevenOfWands": "Seven of Wands",
            "eightOfWands": "Eight of Wands",
            "nineOfWands": "Nine of Wands",
            "tenOfWands": "Ten of Wands",
            "pageOfWands": "Page of Wands",
            "knightOfWands": "Knight of Wands",
            "queenOfWands": "Queen of Wands",
            "kingOfWands": "King of Wands"
        },
        "lenormand": {
            "rider": "Rider",
            "clover": "Clover",
            "ship": "Ship",
            "house": "House",
            "tree": "Tree",
            "clouds": "Clouds",
            "snake": "Snake",
            "coffin": "Coffin",
            "bouquet": "Bouquet",
            "scythe": "Scythe",
            "whip": "Whip",
            "birds": "Birds",
            "child": "Child",
            "fox": "Fox",
            "bear": "Bear",
            "stars": "Stars",
            "stork": "Stork",
            "dog": "Dog",
            "tower": "Tower",
            "garden": "Garden",
            "mountain": "Mountain",
            "crossroads": "Crossroads",
            "mice": "Mice",
            "heart": "Heart",
            "ring": "Ring",
            "book": "Book",
            "letter": "Letter",
            "man": "Man",
            "woman": "Woman",
            "lily": "Lily",
            "sun": "Sun",
            "moon": "Moon",
            "key": "Key",
            "fish": "Fish",
            "anchor": "Anchor",
            "cross": "Cross"
        }
    },
    "cardDialog": {
        "primaryMeaning": "Primary Meaning",
        "interpretation": "Interpretation",
        "reversed": "Reversed"
    },
    "cardCategories": {
        "majorArcana": "Major Arcana",
        "cups": "Cups",
        "pentacles": "Pentacles",
        "swords": "Swords",
        "wands": "Wands"
    },
    "pages": {
        "journal": "Journal",
        "shareFeedback": "Share Feedback",
        "readingCards": "Reading Cards",
        "reading": "Reading",
        "displayReading": "Display Reading",
        "modeSelector": "Mode Selector",
        "selectReading": "Select Reading",
        "settings": "Settings",
        "payments": "Payments",
        "personalInformation": "Personal Information",
        "personalProfile": "Personal Profile",
        "readingList": "Reading List",
        "notifications": "Notifications",
        "cardMeanings": "Card Meanings",
        "chat": "Chat"
    },
    "readingPage": {
        "yourQuestion": "🪄 The energy of your reading is based on this question:",
        "theSpread": "The Spread",
        "cardInteractions": "Card Interactions",
        "conclusion": "Conclusion",
        "practicalAdvice": "Practical Advice",
        "readMore": "Read More",
        "touchCardsInfo": "Touch the cards for more information",
        "noReadingsFound": "No readings found",
        "tryNewReading": "Try doing a new reading first!",
        "startAudioReading": "🎧 Start Audio Reading"
    },
    "home": {
        "dailyReading": "Your Daily Reading",
        "completeReading": "Complete Reading",
        "favoriteReadingTypes": "Your Favorite Reading Types",
        "dailyReadingPrompt": "Discover the message the universe has for you today",
        "chooseCard": "Choose Your Card",
        "getPremium": {
            "bestValue": "Best Value",
            "title": "Get Premium",
            "description": "Nearly Unlimited Personalized Readings"
        },
        "statistics": {
            "topSuit": "Top Suit",
            "topNumberOrRank": "Top Number or Rank",
            "last7Days": "Last 7 Days"
        }
    },
    "credits": {
        "availableCredits": "Available Credits",
        "buyCredits": "Buy Credits",
        "creditsDescription": "Credits are used for generating readings and accessing premium features.",
        "betaTestTitle": "Beta Test Credits",
        "betaTestDescription": "You will get 200 credits for free to explore all features during our beta test. These credits will allow you to experience the full potential of our tarot readings!",
        "recentActivity": "Recent Activity",
        "noRecentActivity": "No recent activity",
        "creditsUpdatedSuccess": "Credits updated successfully!",
        "loading": "Loading..."
    },

    "personalInfo": {
        "title": "Personal Information",
        "description": "Update your personal information. More you share, more we can help you.",
        "firstName": "First Name",
        "lastName": "Last Name",
        "username": "Username",
        "email": "Email",
        "password": "Password",
        "dateOfBirth": "Date of Birth",
        "preferredLanguage": "Preferred Language",
        "selectPreferredLanguage": "Select Preferred Language",
        "gender": "Gender",
        "selectGender": "Select gender",
        "male": "Male",
        "female": "Female",
        "other": "Other",
        "preferNotToSay": "Prefer not to say",
        "birthdate": "Birthdate",
        "changePassword": "Change Password",
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "confirmPassword": "Confirm Password",
        "address": "Address",
        "street": "Street",
        "number": "Number",
        "complement": "Complement",
        "zipCode": "ZIP Code",
        "city": "City",
        "state": "State",
        "country": "Country",
        "selectCountry": "Select country",
        "unitedStates": "United States",
        "canada": "Canada",
        "france": "France",
        "germany": "Germany",
        "validation": {
            "firstNameRequired": "First name is required",
            "lastNameRequired": "Last name is required",
            "birthdateRequired": "Birthdate is required",
            "currentPasswordRequired": "Current password is required to change password",
            "passwordMinLength": "Password must be at least 8 characters long",
            "passwordUppercase": "Password must contain at least one uppercase letter",
            "passwordLowercase": "Password must contain at least one lowercase letter",
            "passwordNumber": "Password must contain at least one number",
            "passwordsDoNotMatch": "Passwords do not match",
            "streetNumberRequired": "Street number is required when street is provided",
            "invalidZipCode": "Invalid ZIP code format"
        },
        "messages": {
            "profileSavedSuccess": "Profile saved successfully!",
            "failedToUpdateProfile": "Failed to update profile. Please try again.",
            "noAuthToken": "No authentication token found"
        }
    },
    "personalProfile": {
        "title": "Personal Profile",
        "experienceLevel": "Experience Level",
        "selectExperienceLevel": "Select Experience Level",
        "preferredReadingStyle": "Preferred Reading Style",
        "selectPreferredReadingStyle": "Select Preferred Reading Style",
        "useReversedCards": "Use Reversed Cards",
        "primaryLifeFocus": "Primary Life Focus",
        "selectPrimaryLifeFocus": "Select Primary Life Focus",
        "intentions": "Intentions",
        "selectIntentions": "Select Intentions",
        "language": "Language",
        "selectLanguage": "Select Language"
    },
    "billing": {
        "title": "Read your cards, any time and get personalized answers.",
        "credits": "Credits",
        "betterValue": "BETTER VALUE",
        "bestValue": "BEST VALUE",
        "creditsNeverExpire": "Credits never expire and are only redeemed for questions that can be answered with tarot.",
        "buyQuestions": "BUY {{count}} QUESTIONS",
        "processingPurchase": "Processing your purchase, this may take a moment...",
        "purchaseSuccessPolling": "Purchase successful! Your credits will be updated in a few moments.",
        "purchaseDelayed": "Purchase successful! Credits will be updated shortly.",
        "purchaseFailed": "Purchase failed: {{error}}"
    },
    "payment": {
        "emailLabel": "Email",
        "emailPlaceholder": "Enter your email",
        "cardDetailsLabel": "Card details",
        "processing": "Processing...",
        "buyNow": "Buy Now",
        "errorInvalidPriceId": "Error: Invalid price ID",
        "errorCardElementNotFound": "Card element not found.",
        "errorAuthTokenNotFound": "Authentication token not found",
        "successPayment": "Payment successful! You will receive a confirmation email shortly.",
        "errorInvalidPriceIdDetail": "Invalid price ID: {{priceId}}",
        "errorUnknown": "An unknown error occurred",
        "errorPrefix": "Error: "
    },
    "welcomeSpread": {
        "initialMessage": "Breathe with me for a moment.\nIn a few words: what situation do you seek clarity about today?",
        "thankYouMessage": "Thank you for sharing. I'm here to help you find clarity.",
        "placeholder": "Type your message...",
        "recording": "Recording..."
    },
    "navigation": {
        "today": "Today",
        "journal": "Journal",
        "new": "New",
        "readings": "Readings",
        "feedback": "Feedback",
        "settings": "Settings"
    },
    "profileOptions": {
        "experienceLevels": {
            "newToTarot": "New to tarot",
            "someExperience": "Some experience",
            "experiencedReader": "Experienced reader"
        },
        "readingFrequencies": {
            "daily": "Daily",
            "weekly": "Weekly",
            "occasionally": "Occasionally"
        },
        "deckPreferences": {
            "riderWaite": "Rider-Waite",
            "celestialMinimalist": "Celestial Minimalist",
            "thoth": "Thoth"
        },
        "userGoals": {
            "loveRelationships": "Love / Relationships",
            "careerFinances": "Career / Finances",
            "personalGrowth": "Personal Growth",
            "healthWellbeing": "Health / Well-being",
            "curiosityExploration": "Curiosity / Exploration"
        },
        "aiTonePreferences": {
            "directPractical": "Direct and practical",
            "gentleIntuitive": "Gentle and intuitive",
            "deepSymbolic": "Deep and symbolic"
        },
        "languages": {
            "english": "English",
            "portuguese": "Portuguese",
            "spanish": "Spanish",
            "french": "French",
            "german": "German"
        }
    },
    "reading": {
        "wasThisHelpful": "Was this reading helpful?",
        "helpful": "Helpful",
        "notHelpful": "Not Helpful",
        "helpfulSuccess": "Thank you for your feedback!",
        "notHelpfulSuccess": "Thank you for your feedback!",
        "evaluationError": "Failed to save your evaluation"
    },
    "cardSelection": {
        "title": "Select Your Cards",
        "cardsSelected": "{{count}} / {{max}} cards selected",
        "shuffleCards": "Shuffle Cards",
        "shuffling": "Shuffling...",
        "selectionComplete": "Selection Complete..."
    },
    // Import readingTypes from external file
    readingTypes,
    cardsTranslations: cards.cardsTranslations
};

export default enUSTranslations; 